﻿import DefaultApp from './defaultApp';

import ProfileItem from './components/ProfileItem.vue';

import bulmaCollapsible from '@creativebulma/bulma-collapsible';

const profileApp = {
    ...DefaultApp,
    components: {
        ...DefaultApp.components,
        ProfileItem,
    },
    data() {
        return {
            ...DefaultApp.data(),
            dataTopicLabel: '',
            dataDepartmentLabel: '',
            selectedLetters: [],
            originalFacets: [],
        }
    },
    computed: {
        ...DefaultApp.computed,
        filtersChosen() {
            return (this.facetsSet && this.data.facets.some(facet => facet.values.length)) || this.dataOverruleIds.length || this.searchText || this.selectedLetters.length;
        },
        filtersActive() {
            return (this.facetsSet && this.data.facets.some(facet => facet.selected) || this.searchText || this.selectedLetters.length);
        },
        filterItems() {
            if (!this.filtersChosen) return [];
            if (this.dataOverruleIds.length) {
                return [
                    {
                        Key: this.constants.filterAliases.id,
                        Values: this.dataOverruleIds,
                        Operator: this.constants.operators.in,
                    }
                ]
            }
            return this.data.facets.filter(facet => facet.values.length && facet.inputType === this.constants.inputTypes.select).map(facet => {
                return {
                    Key: facet.alias,
                    Values: facet.values.map(option => option.valueAlias),
                    Operator: this.constants.operators.in,
                }
            });
        },
        queryModel() {
            return {
                Limit: this.dataLimit,
                Offset: 0,
                OrderItems: this.orderItems,
                FilterItems: this.filterItems,
                Text: this.searchText
            }
        },
        departments() {
            if (!this.itemsSet) return [];
            let departments = this.data.items.map(item => item.department.map(department => department.name)).flat();
            return [...new Set(departments)].sort((a, b) => a - b);
        },
        letters() {
            return this.constants.filters.alphabet.split('');
        },
        enabledLetters() {
            if (!this.itemsSet) return [];
            return [...new Set(this.data.items.map(item => item.name.split(' ').map(w => w.charAt(0).toLowerCase())).flat())];
        },
        filteredItems() {
            if (!this.itemsSet) return [];
            if (!this.selectedLetters.length) return this.data.items;
            return this.data.items.filter(item => {
                let words = item.name.split(' ');
                return words.some(w => this.selectedLetters.includes(w.charAt(0).toLowerCase()));
            });
        },
    },
    methods: {
        ...DefaultApp.methods,
        async init() {
            this.loading = true;

            if (this.$el.dataset.widget) this.dataWidget = this.$el.dataset.widget;
            if (this.$el.dataset.overruleids) this.dataOverruleIds = this.$el.dataset.overruleids.split(',');
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
            if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
            if (this.$el.dataset.topiclabel) this.dataTopicLabel = this.$el.dataset.topiclabel;
            if (this.$el.dataset.departmentlabel) this.dataDepartmentLabel = this.$el.dataset.departmentlabel;
  
            const urlParams = new URLSearchParams(window.location.search);

            this.searchText = urlParams.has(this.constants.queryParams.text) ? urlParams.get(this.constants.queryParams.text) : '';
            if (this.searchText) urlParams.delete(this.constants.queryParams.text);
            let filterParams = urlParams.toString() ? urlParams : null;
            if (filterParams) {
                const facetsResponse = await this.fetchData();
                this.setFacets(facetsResponse);
                this.data.facets.forEach(facet => {
                    if (filterParams.has(facet.title)) {
                        let valueArray = filterParams.get(facet.title).split(',');
                        facet.values = valueArray.map(alias => facet.options.find(option => option.valueAlias === alias));
                    }
                });
                if (filterParams.has(this.constants.queryParams.letters)) {
                    this.selectedLetters = filterParams.get(this.constants.queryParams.letters).split(',');
                }
            }

            if (this.dataOverruleIds.length) {
                const overruleResponse = await this.fetchData();
                if (overruleResponse && overruleResponse.data && overruleResponse.data.items && overruleResponse.data.items.length) {
                    overruleResponse.data.items = overruleResponse.data.items.sort((a, b) => this.dataOverruleIds.indexOf(a.id) - this.dataOverruleIds.indexOf(b.id));
                }
                this.setData(overruleResponse, true);
                this.dataOverruleIds = [];
            }

            const response = await this.fetchData();
            let replace = !this.itemsSet;
            this.setData(response, replace);

            if (this.itemsSet) {
                this.data.items = this.removeDuplicatesById(this.data.items);
                if (this.dataWidget) this.data.items = this.data.items.slice(0, this.dataLimit);
            }

            this.loading = false;
        },
        setFacets(response) {
            if (!response || response.status != 200 || !response.data.facets) return;
            this.data.facets = response.data.facets.sort((a, b) => a.sortOrder - b.sortOrder).map(facet => {
                let label = facet.alias;
                switch (facet.alias) {
                    case this.constants.filterAliases.topics:
                        label = this.dataTopicLabel;
                        break;
                    case this.constants.filterAliases.departments:
                        label = this.dataDepartmentLabel;
                        break;
                    default:
                        break;
                }

                return {
                    ...facet,
                    values: facet.options.filter(option => option.selected),
                    label: label,
                }
            });
            this.originalFacets = JSON.parse(JSON.stringify(this.data.facets));
            this.filterFacets();
        },
        reset() {
            this.data.facets.forEach(facet => facet.values = []);
            this.selectedLetters = [];
            this.searchText = '';
            this.loading = true;
            this.fetchInitialData();
            this.loading = false;
        },
        updateUrl() {
            if (!this.filtersActive) {
                history.pushState({}, null, window.location.pathname);
                window.dispatchEvent(new CustomEvent('update-url'));
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.queryModel.Text) urlParams.set(this.constants.queryParams.text, this.queryModel.Text);
            if (this.queryModel.FilterItems.length) {
                this.queryModel.FilterItems.forEach(filterItem => {
                    let facet = this.data.facets.find(facet => facet.alias === filterItem.Key);
                    if (facet) urlParams.set(facet.title, filterItem.Values.join());
                });
            }
            if (this.selectedLetters.length) urlParams.set(this.constants.queryParams.letters, this.selectedLetters.join());
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
            window.dispatchEvent(new CustomEvent('update-url'));
        },
        checkDepartment(item, department) {
            if (!item || !item.department || !item.department.length || !department) return false;
            return item.department.some(dep => dep.name === department);
        },
        toggleLetter(letter) {
            if (!letter) return;
            if (this.selectedLetters.includes(letter)) {
                this.selectedLetters = this.selectedLetters.filter(l => l !== letter);
            }
            else {
                this.selectedLetters.push(letter);
            }
            this.filterFacets();
            this.updateUrl();
        },
        filterFacets() {
            if (!this.facetsSet || !this.selectedLetters.length) {
                this.data.facets = JSON.parse(JSON.stringify(this.originalFacets));
            }
            else {
                this.data.facets = this.data.facets.map(facet => {
                    return {
                        ...facet,
                        options: facet.options.map(option => {
                            return {
                                ...option,
                                filteredAmount: this.filteredItems.filter(item => item.topics.some(t => t.name === option.valueAlias)).length,
                            };
                        })
                    };
                });
            }
        }
    },
    updated() {
        if (!this.dataWidget) {
            let collapsibles = this.$el.querySelectorAll('.is-collapsible');
            collapsibles.forEach($collapsible => {
                if (window.getComputedStyle($collapsible).height != '0px') bulmaCollapsible.attach($collapsible);
            });
        }
    },
};

export default profileApp;
